<template>
  <div class="top-bar-page share-page page-padding-top">
    <top-bar :title="i18n.t('share.title')"  @back="back"></top-bar>

    <div class="top-info flex-column-start-center banner2">
      <div class="title">{{$t('share.desc1')}}</div>
      <div class="sub-title">{{$t('share.desc2')}}</div>
    </div>

    <div class="share-box">
      <div class="modal-title" >{{i18n.t('share.label1')}}</div>

      <div class="share-modal">
        <div class="flex-center-between share-line" >
          <div class="label">{{$t('share.label2')}}</div>
          <div class="flex-center">
            {{shareLink}}
            <img :src="copyUrl" alt="" class="copy-icon" @click="copyData(2)">
          </div>
        </div>
        <div class="flex-center-between share-line">
          <div class="label">{{i18n.t('share.label3')}}</div>
          <div class="flex-center ">
            {{shareCode}}
            <img :src="copyUrl" alt="" class="copy-icon" @click="copyData(1)">
          </div>
        </div>
      </div>

      <div class="share-modal" @click="toPath('myShare')">
        <div class="flex-center-between share-line" >
          <div class="label flex-center">
            <img :src="shareUrl2" alt="">
            {{$t('share.label4')}}
          </div>
          <div class="flex-center">
            + 0.00 USDT
            <Icon name="arrow" size="16" color="#85898F"></Icon>
          </div>
        </div>
      </div>
      <div class="share-modal" @click="toPath('shareRole')">
        <div class="flex-center-between share-line" >
          <div class="label flex-center">
            {{$t('share.label5')}}
          </div>
          <div class="flex-center">
            <Icon name="arrow" size="16" color="#85898F"></Icon>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import topBar from '@/components/topBar'
import Clipboard from 'clipboard';
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
import { Button, Popup, Icon } from 'vant'
export default {
  components: {
    Button,
    Popup,
    Icon,
    topBar
  },
  data() {
    return {
      noticeList: [],
      shareUrl2: require('../../assets/imgs/icon-share2.png'),
      copyUrl: require('../../assets/imgs/icon-copy.png'),
      closeUrl: require('../../assets/imgs/icon-close.png'),
      showShare: false,
    }
  },
  computed: {
    shareLink() {
      return this.$store.state.promoteUrl + '#/register?code=' + this.shareCode
    },
    shareCode() {
      return this.$store.state.shareCode
    },
    screenScale() {
      return this.$store.state.screenScale
    },
  },
  mounted() {
  },
  methods: {
    init() {

    },
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    copyData(type) {
      let data = type == 1 ? this.shareCode : this.shareLink
      const clipboard = new Clipboard('.copy-icon', {text: () => data});
      this.$toast.success(this.i18n.t('recharge.success'))
    },
    showModal() {
      this.showShare = true
      this.$nextTick(() => {
        document.getElementById('qrcode').innerHTML = ''
        let qrcode = new QRCode(this.$refs.qrcode, {
          text: this.shareLink,
          width: 63 * this.screenScale,
          height: 63 * this.screenScale,
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    cancel() {
      this.showShare = false
    },
    linkClick(i) {
      if (i == 0) {
        this.copyData(2)
      } else if (i == 1) {
        html2canvas(this.$refs.modalRef).then(canvas => {
          let a = document.createElement('a')
          a.href = canvas.toDataURL("image/png")
          a.download = `${this.i18n.t('share.img')}.png`
          var clickevent = document.createEvent('MouseEvents');
          clickevent.initEvent('click', true, false);
          a.dispatchEvent(clickevent);
        })
      }
    }
  }
}
</script>